import { BaseEntity } from ".";
import { IGet_corporations_corporation_id_membertracking_200_ok } from "../service/esiclient";
import moment from "moment";
import { getCachedCharacterEntity } from "./CharacterEntityCache";
import { getCachedStationEntity } from "./StationEntityCache";

export class CorporationMemberEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Corporation Member";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const props: Partial<IGet_corporations_corporation_id_membertracking_200_ok> = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      entity.properties["id"] = {
        type: Excel.CellValueType.double,
        basicValue: id,
      };
      let character = null;
      if (props.character_id) {
        character = await getCachedCharacterEntity(props.character_id);
        entity.properties["name"] = {
          type: Excel.CellValueType.string,
          basicValue: character?.props.name,
        };
        entity.text = character?.props.name;
      }
      // - Image
      entity.properties["image"] = {
        type: Excel.CellValueType.webImage,
        address: `https://images.evetech.net/characters/${id}/portrait?tenant=tranquility&size=256`,
        altText: character?.props.name,
      };
      if (props.location_id) {
        entity.properties["location_id"] = {
          type: Excel.CellValueType.double,
          basicValue: props.location_id,
        };
        const stationEntity = await getCachedStationEntity(props.location_id);
        if (stationEntity !== null) {
          entity.properties["location"] = await stationEntity.toJson(true);
        }
      }
      if (props.logoff_date) {
        const logoff_date = moment(props.logoff_date);
        entity.properties["logoff_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: logoff_date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }

      if (props.logon_date) {
        const logon_date = moment(props.logon_date);
        entity.properties["logon_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: logon_date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.ship_type_id) {
        entity.properties["ship_type_id"] = {
          type: Excel.CellValueType.double,
          basicValue: props.ship_type_id,
        };
      }

      if (props.start_date) {
        const startdate = moment(props.start_date);
        entity.properties["start_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: startdate.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.base_id) {
        entity.properties["base_id"] = {
          type: Excel.CellValueType.double,
          basicValue: props.base_id,
        };
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
        mainImage: { property: "image" },
      },
      compact: {
        icon: "NotablePeople",
      },
    };

    return entity;
  }
}
